import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import imagen from '../../assets/img/check.svg';
import '../../css/ModalValidacionExitosa.css';


const ModalConfirmacionExitosa = ({ show, onClose, onReset }) => {
  const handleContinuar = () => {
    if (onReset) onReset(); // Limpia los campos en el componente padre
    onClose();
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      backdrop="static"
      dialogClassName="modal-confirmacion-exitosa"
    >
      <Modal.Body>
        <div className="contenido-modal-confirmacion text-center">
          <img src={imagen} alt="Éxito" className="icono-validacion" />
          <h4 className="titulo-validacion" style={{marginTop:'10px'}}>¡Tu registro fue exitoso!</h4>
          <p className="mensaje-validacion" style={{marginTop:'10px'}}>
             Hemos registrado tu participación. <br/>Publicaremos los resultados del sorteo en nuestra web.
          </p>
          <p style={{color: '#8f1a95', fontWeight: '700', marginTop:'10px'}}>¡Muchísima suerte!</p>
          <Button
            variant="primary"
            onClick={handleContinuar}
            className="boton-cerrar"
          >
            ¡Listo!
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ModalConfirmacionExitosa;